( function() {
    "use strict";

    angular
        .module('ccsTrApp')
        .controller( 'LotDetailModalController', LotDetailModalController );

    LotDetailModalController.$inject = [ 'entity', '$uibModalInstance', 'ContractCustomService', 'ShipmentCustomService', 'CommentCustomService', 'AttachmentCustomService', 'ToastrService' ];

    function LotDetailModalController( entity, $uibModalInstance, ContractCustomService, ShipmentCustomService, CommentCustomService, AttachmentCustomService, ToastrService ) {

        var vm = this;

        vm.lot = entity;
        fetchLazyStuff();

        vm.close = close;

        function close() {
            $uibModalInstance.dismiss('cancel');
        }

        function fetchLazyStuff() {
            vm.actualWeightNet = 0;
            vm.actualWeightGross = 0;
            vm.actualWeightTare = 0;
            vm.actualWeightAvg = 0;
            vm.landedWeightNet = 0;
            vm.landedWeightGross = 0;
            vm.landedWeightTare = 0;
            vm.landedWeightAvg = 0;
            switch( vm.lot.purchWtType ) {
                case 'KG':
                    vm.actualWeightNet = vm.lot.purchLandedNetKgs;
                    vm.actualWeightGross = vm.lot.purchLandedGrossKgs;
                    vm.actualWeightTare = vm.lot.purchLandedTareKgs;
                    vm.actualWeightAvg = vm.lot.actualWtAvg;
                    vm.landedWeightNet = vm.lot.purchLandedNetKgs;
                    vm.landedWeightGross = vm.lot.purchLandedGrossKgs;
                    vm.landedWeightTare = vm.lot.purchLandedTareKgs;
                    vm.landedWeightAvg = vm.lot.landedWtAvg;
                    break;
                case 'LB':
                    vm.actualWeightNet = vm.lot.purchLandedNetLbs;
                    vm.actualWeightGross = vm.lot.purchLandedGrossLbs;
                    vm.actualWeightTare = vm.lot.purchLandedTareLbs;
                    vm.actualWeightAvg = vm.lot.actualWtAvg;
                    vm.landedWeightNet = vm.lot.purchLandedNetLbs;
                    vm.landedWeightGross = vm.lot.purchLandedGrossLbs;
                    vm.landedWeightTare = vm.lot.purchLandedTareLbs;
                    vm.landedWeightAvg = vm.lot.landedWtAvg;
                    break;
                case 'MT':
                    vm.actualWeightNet = vm.lot.purchLandedNetMTs;
                    vm.actualWeightGross = vm.lot.purchLandedGrossMTs;
                    vm.actualWeightTare = vm.lot.purchLandedTareMTs;
                    vm.actualWeightAvg = vm.lot.actualWtAvg;
                    vm.landedWeightNet = vm.lot.purchLandedNetMTs;
                    vm.landedWeightGross = vm.lot.purchLandedGrossMTs;
                    vm.landedWeightTare = vm.lot.purchLandedTareMTs;
                    vm.landedWeightAvg = vm.lot.landedWtAvg;
                    break;
            }

            vm.saleValue = vm.lot.saleValue;
            vm.landedValue = vm.lot.landedValue;
            vm.difference = vm.landedValue - vm.saleValue;

            if( vm.lot.id != null ) {
                vm.comments = [];
                CommentCustomService.returnCommentsByLot( vm.lot.id ).then( function( data ) {
                    vm.comments = data.data;
                }, function( error ) {
                    if( error.status != 404 ) {
                        ToastrService.error( "Failed to fetch Comments", "Error!" );
                    }
                });
                vm.attachments = [];
                AttachmentCustomService.returnAttachmentsByLot( vm.lot.id ).then( function( data ) {
                    vm.attachments = data.data;
                }, function( error ) {
                    if( error.status != 404 ) {
                        ToastrService.error( "Failed to fetch Attachments", "Error!" );
                    }
                });
                //fetch purchase contract
                vm.purchaseContract = null;
                ContractCustomService.returnMinifiedContractForLotDetailModalByTypeAndLotId("PURCHASE", vm.lot.id).then(function(data) {
                    vm.purchaseContract = data.data;
                    vm.lot.purchase = vm.purchaseContract;
                }, function(error) {
                    if(error.status !== 404 ) {
                        ToastrService.error("Failed to fetch Purchase Contract", "Error");
                    }
                });
                //fetch sale contract
                vm.saleContract = null;
                ContractCustomService.returnMinifiedContractForLotDetailModalByTypeAndLotId("SALE", vm.lot.id).then(function(data) {
                    vm.saleContract = data.data;
                    vm.lot.allocSale = vm.saleContract;
                }, function(error) {
                    if(error.status !== 404) {
                        ToastrService.error("Failed to fetch Sale Contract", "Error");
                    }
                });
                //fetch shipment
                vm.shipment = null;
                ShipmentCustomService.returnMinifiedShipmentForLotDetailModalByLotId(vm.lot.id).then(function(data) {
                    vm.shipment = data.data;
                    vm.lot.purchSi = vm.shipment;
                }, function(error) {
                    if(error.status !== 404) {
                        ToastrService.error("Failed to fetch Shipment", "Error");
                    }
                });
            }
        }
    }
})();
